import React, { memo } from 'react';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { SingleTaskPart } from '../styles';
import { IProviderItemView } from '../../../../../store/providers/providerTypes';

interface IProviderItemNamePartProps {
  taskId: number;
  property: IProviderItemView[];
  item: {
    options?: any;
    value: string;
  };
}

const ProviderItemNamePart: React.FC<IProviderItemNamePartProps> = ({
  taskId,
  property,
  item: {
    options: { view },
  },
}) => (
  <PrintSingleTaskConsumer>
    {(dataContext: IPrintSingleTaskContext) => {
      const { company, allTasks, relatedProviderItems } = dataContext;

      const showBothKeyValue = view === 'both';
      let showKey = showBothKeyValue;
      let showValue = showBothKeyValue;

      if (!showBothKeyValue) {
        showKey = view === 'key';
        showValue = view === 'value';
      }

      let providerItemTitle;
      let providerItemName;

      if (showKey) {
        const templateId = allTasks!.find(
          (task) => task.id === taskId
        )!.templateId;
        const companyTemplate = company?.templates?.find(
          (template) => template.taskId === templateId
        );

        providerItemTitle = messages.getProviderItemTitle(
          showBothKeyValue,
          companyTemplate!.task!.relatedProviderItemTitle
        );
      }

      const propertiesIdList = property?.reduce((acc: number[], item) => {
        acc.push(item.id);
        return acc;
      }, []);

      if (showValue) {
        providerItemName =
          (property &&
            relatedProviderItems
              ?.filter((pItem) => propertiesIdList?.includes(Number(pItem.id)))
              .reduce(
                (acc: string, item) =>
                  acc.length > 0 ? `${acc} - ${item.name}` : item.name || '',
                ''
              )) ??
          messages.fieldIsEmpty;
      }

      return (
        <SingleTaskPart>
          <span>{showKey && providerItemTitle}</span>
          <span>{showValue && providerItemName}</span>
        </SingleTaskPart>
      );
    }}
  </PrintSingleTaskConsumer>
);

export default memo(ProviderItemNamePart);
